<div *ngIf="filteredCitizenServices$ | async as citizensServices" class="w-full mt-4">

  <div class="w-full flex md:flex-row flex-col items-center  mt-2 border-b-2 border-primary-500">
    <div class="flex-grow-1">
      <app-portal-title-bar [hideBackButton]="hideBackButton"
                            [title]="'Orodha ya Huduma' |concat|translate"></app-portal-title-bar>
    </div>
    <div class="pb-2 flex items-center gap-2 ">
      <div class="group border border-primary-500 inline-flex flex-grow self-end rounded-md
       items-center transition-all duration-300 bg-white px-2 py-1 focus-within:border-primary-500">
        <input
          class="outline-none bg-white px-2 py-2 text-primary-500"
          id="search"
          placeholder="{{'Tafuta huduma'|concat|translate}}"
          type="text"
          (input)="searchData($event.target.value)"
        />
        <mat-icon
          class="text-primary-500 text-sm"
          svgIcon="search"
        ></mat-icon>
      </div>
<!--      <div (click)="showFilter = !showFilter" class="cursor-pointer px-3 py-2 rounded-md border border-primary-500">-->
<!--        <mat-icon-->
<!--          class="text-primary-500 text-sm rotate-90"-->
<!--          svgIcon="landingFilter"-->
<!--        ></mat-icon>-->
<!--      </div>-->
    </div>
  </div>

  <!-- END: Search Badges -->

  <!--  <div class=" py-3 mx-auto px-2">-->
  <!--    @if (showFilter) {-->
  <!--      <app-service-filter-banner></app-service-filter-banner>-->
  <!--    } @else {-->
  <!--      <app-service-statistics-banner></app-service-statistics-banner>-->
  <!--    }-->
  <!--  </div>-->

  <ng-container [ngTemplateOutlet]="banner"></ng-container>

  <div *ngIf="citizensServices?.length;  else noService" class="mt-3">
    <div class="grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 gap-3">
      @for (service of citizensServices; track service?.id) {
        <app-service-item [userIsLoggedIn]="hideBackButton" [service]="service"></app-service-item>
      }
    </div>
    <app-paginator
      (page)="loadNextData($event)"
      [currentPage]="pageObject?.currentPageNumber"
      [nextPage]="pageObject?.nextPageNumber"
      [pageCount]="15"
      [pagesNumberArray]="pageObject?.pagesNumberArray"
      [prevPage]="pageObject?.previousPageNumber"
      class="my-2"></app-paginator>
  </div>
  <ng-template #noService>
    <div class="bg-white col-md-10 mt-4 mx-auto rounded-md p-4 text-center font-medium text-muted move-left">
      {{ "no_services" | translate }}
    </div>
  </ng-template>
</div>
